import * as address from 'smg/address';
import * as html from 'smg/html';
import * as models from 'smg/models';
import * as smgphone from 'smg/phone';
import * as template from 'smg/template';

export const Format = address.Format;

export async function Draw(address: address.Address | models.ShippingOption | models.PaymentOption, phone?: string, email?: string, el: HTMLElement = template.Clone('#address-template')): Promise<HTMLElement> {
    const lines = el.querySelector('.address-lines');
    if (lines) {
        lines.innerHTML = html.Nl2br(await Format(address));
    }

    const phoneEl = el.querySelector<HTMLAnchorElement>('.address-phone');
    if (phone) {
        if (phoneEl) {
            phoneEl.textContent = smgphone.Human(phone);
            phoneEl.href = smgphone.Format(phone);
        }
    } else if (!phone) {
        phoneEl?.remove();
    }

    const emailEl = el.querySelector<HTMLAnchorElement>('.address-email');
    if (email) {
        if (emailEl) {
            emailEl.textContent = email;
            emailEl.href = `mailto:${email}`;
        }
    } else if (!email) {
        emailEl?.remove();
    }

    return el as HTMLElement;
}